/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createCot } from '../../factoriesAny.js';
export var cotDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  typedDependencies: typedDependencies,
  createCot: createCot
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesCot.generated.js
// module id = 1375
// module chunks = 0